import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var segmentedStyle = function segmentedStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    titleColor1 = _getThemeData.titleColor1;
  return css([".c7n-pro-segmented{&-wrapper&-wrapper&-wrapper{.c7n-pro-segmented{.c7n-pro-radio-wrapper{&.c7n-pro-radio-button{.c7n-pro-radio-inner.c7n-pro-radio-inner{:after{content:'' !important;}}}}}}.c7n-pro-radio-wrapper.c7n-pro-radio-wrapper.c7n-pro-radio-button:not( .c7n-pro-table-customization-select-view-option ) .c7n-pro-radio:checked + .c7n-pro-radio-inner + span{color:", ";font-weight:500;}}"], titleColor1);
};
export default segmentedStyle;